export default "__VITE_ASSET__DGEbvHCh__"